import { createFileRoute } from '@tanstack/react-router'
import { EntriesPage } from '@/pages/Entries'

export const Route = createFileRoute('/_authenticated/entries')({
  component: EntriesPage,
})
